"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Drawer, Progress } from "@mantine/core";
import { useCart } from "@/contexts/cartContext";
import Link from "next/link";
import Image from "next/image";
import { mediaUrl } from "@/lib/config/app";
import EmptyCart from "../../cart/EmptyCart";
import { Icon } from "@iconify/react";
export default function SideCart() {
  const $ = _c(39);
  const {
    cartCount,
    sidecartOpen,
    setSidecartOpen,
    cartItems,
    removeCartItem,
    cartLoading,
    cartSummary,
    qualifiesForFreeDelivery,
    remainingForFreeDelivery,
    freeDeliveryProgress,
    minCheckoutPrice
  } = useCart();
  const cartTotal = Number(cartSummary?.subtotal || 0);
  let t0;
  if ($[0] !== setSidecartOpen) {
    t0 = () => setSidecartOpen(false);
    $[0] = setSidecartOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      transition: "slide-left",
      duration: 150,
      timingFunction: "linear"
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `My Cart (${cartCount})`;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      body: {
        padding: "4px",
        maxHeight: "calc(100dvh - 40px)",
        height: "99%"
      },
      header: {
        padding: "4px",
        minHeight: "40px"
      }
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = !cartLoading;
  const t5 = !cartLoading;
  let t6;
  if ($[4] !== cartItems || $[5] !== removeCartItem) {
    t6 = cartItems && cartItems.length > 0 ? cartItems.map((item, idx) => {
      const price = item.product.price || 0;
      return <div key={idx} className="mb-2 pb-2 border-b border-gray-200 px-1"><div className="flex items-center gap-2"><div className="w-1/6"><Image className="rounded-xl w-13 h-13 shadow border border-gray-200 object-contain" src={`${mediaUrl}${item.variant.variant_image || item.product.featured_image || "noimage.png"}`} alt={item.product.title} width={48} height={48} /></div><div className="w-5/6"><div className="line-clamp-1 text-xs font-heading">{item.product.title}</div>{item.options?.map(_temp)}<div className="text-xs font-medium leading-tight">Price: £{price.toFixed(2)}</div><div className="flex items-center gap-2"><div className="text-xs leading-tight">Qty: {item.quantity}</div><span className="text-red-600 leading-tight border-0 text-xs lg:text-sm cursor-pointer" title="remove" onClick={() => removeCartItem({
                variant_id: item.variant_id
              })}>Remove</span></div></div></div></div>;
    }) : <EmptyCart compact={true} />;
    $[4] = cartItems;
    $[5] = removeCartItem;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t6) {
    t7 = <div className="overflow-y-auto">{t6}</div>;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== cartTotal || $[10] !== freeDeliveryProgress || $[11] !== qualifiesForFreeDelivery || $[12] !== remainingForFreeDelivery) {
    t8 = cartTotal > 0 && !qualifiesForFreeDelivery && <div className="pt-1"><p className="text-black flex items-center gap-1"><Icon icon="fa6-solid:truck-fast" className="me-1" />Add <strong>£{remainingForFreeDelivery.toFixed(2)}</strong> more for free delivery!</p><Progress value={freeDeliveryProgress} size="md" radius="md" color="green" animated={true} /></div>;
    $[9] = cartTotal;
    $[10] = freeDeliveryProgress;
    $[11] = qualifiesForFreeDelivery;
    $[12] = remainingForFreeDelivery;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== cartTotal || $[15] !== qualifiesForFreeDelivery) {
    t9 = qualifiesForFreeDelivery && cartTotal > 0 && <div className="text-green-700 text-center"><small className="flex justify-center gap-2 items-center"><Icon icon="fa6-regular:circle-check" className="text-xl" /><strong>You qualify for free delivery!</strong><Icon icon="fa6-solid:truck-fast" className="text-xl" /></small></div>;
    $[14] = cartTotal;
    $[15] = qualifiesForFreeDelivery;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== cartTotal) {
    t10 = cartTotal > 0 && <div className="flex justify-between items-center"><div className="text-xl font-heading">Total:</div><div className="font-heading text-base">£{cartTotal.toFixed(2)}</div></div>;
    $[17] = cartTotal;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== cartCount || $[20] !== cartTotal || $[21] !== minCheckoutPrice || $[22] !== setSidecartOpen) {
    t11 = cartCount > 0 && <><Link href="/cart"><Button onClick={() => setSidecartOpen(false)} fullWidth={true} color="var(--color-slate-900)" size="sm" tt="uppercase">View Cart</Button></Link>{minCheckoutPrice < cartTotal ? <Link href="/cart"><Button onClick={() => setSidecartOpen(false)} fullWidth={true} color="var(--color-red-700)" size="sm" tt="uppercase">Checkout</Button></Link> : <Button onClick={() => setSidecartOpen(false)} fullWidth={true} color="var(--color-red-700)" size="xs" tt="uppercase">Minimum checkout Price £{minCheckoutPrice}</Button>}</>;
    $[19] = cartCount;
    $[20] = cartTotal;
    $[21] = minCheckoutPrice;
    $[22] = setSidecartOpen;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = <div className="flex flex-col gap-2 pt-2 min-h-18.75">{t8}{t9}{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t7) {
    t13 = <div className="flex flex-col justify-between h-full">{t7}{t12}</div>;
    $[29] = t12;
    $[30] = t7;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== sidecartOpen || $[33] !== t0 || $[34] !== t13 || $[35] !== t2 || $[36] !== t4 || $[37] !== t5) {
    t14 = <Drawer opened={sidecartOpen} onClose={t0} transitionProps={t1} position="right" size="xs" title={t2} styles={t3} closeOnClickOutside={t4} closeOnEscape={t5}>{t13}</Drawer>;
    $[32] = sidecartOpen;
    $[33] = t0;
    $[34] = t13;
    $[35] = t2;
    $[36] = t4;
    $[37] = t5;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}
function _temp(opt, j) {
  return <div className="text-xs leading-tight flex items-center gap-1 " key={j}><strong>{opt.name}:</strong> <span className="tracking-tight line-clamp-1 text-[11px]">{opt.value}</span> </div>;
}